import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // T19 — this dropdown's first item used to reuse the shared root
  // `messages.account` ("Account"); it now opens the Account page directly
  // (profile + Subscriptions), so it gets its own label distinct from that
  // shared string, which other call sites still use unchanged.
  accountSettings: {
    id: 'features.settingsDropdown.accountSettings',
    defaultMessage: 'Account settings',
  },
  // T11 fix round 1 — co-located key, split off `Sidebar/SidebarContent/
  // messages.ts`'s `finance` (which the sidebar's own platform-admin row
  // also consumed, under a different meaning — see `adminFinance` there).
  // This is the org-scoped "Billing & Subscriptions" account-menu item.
  billingSubscriptions: {
    id: 'features.settingsDropdown.billingSubscriptions',
    defaultMessage: 'Billing & Subscriptions',
  },
  // Opens `SwitchProfileModal` — shown only when the account belongs to more
  // than one organization (see `showSwitchProfile` in SettingsDropdown).
  switchProfile: {
    id: 'features.settingsDropdown.switchProfile',
    defaultMessage: 'Switch profile',
  },
  // Platform user only — drilled into an organization from the admin
  // Organizations list, this is the way back to the org-less workspace.
  backToWorkspace: {
    id: 'features.settingsDropdown.backToWorkspace',
    defaultMessage: 'Back to workspace',
  },
});

export default messages;
